module.exports = __webpack_public_path__ + "static/myhealth_logo-284c51f61fa6b164749e3c3927b7a64f.png";